import { render, staticRenderFns } from "./ThemeDarkLightSwitch.vue?vue&type=template&id=51e09208"
import script from "./ThemeDarkLightSwitch.vue?vue&type=script&lang=js"
export * from "./ThemeDarkLightSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports